var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGlocation = function SvgGlocation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EAE9F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C17.1 16 18 15.1 18 14C18 12.9 17.1 12 16 12C14.9 12 14 12.9 14 14C14 15.1 14.9 16 16 16ZM16 6C20.2 6 24 9.22 24 14.2C24 17.38 21.55 21.12 16.66 25.43C16.28 25.76 15.71 25.76 15.33 25.43C10.45 21.12 8 17.38 8 14.2C8 9.22 11.8 6 16 6Z",
    fill: "#696593"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGlocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "glocation.9ec914a3e991d8371b2fea9fa86a5034.svg";